import { Form, Formik } from "formik";
import * as Yup from "yup";
import AccountField from "../AccountField";
import useCreateMyInstitution from "api/InstitutionResource/useCreateMyInstitution";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { countries, institutionLevels } from "utils/data";
import useGetProvinces from "api/Province/useGetProvinces";
import { phoneRegex } from "utils";

const CreateInstitution = () => {
	const { data: provinces, isLoading: isLoadingProvinces } = useGetProvinces();
	const { mutateAsync, isLoading } = useCreateMyInstitution();

	const initialValues = {
		name: "",
		level: "",
		address: "",
		country: "Zimbabwe",
		contact_number: "",
		province: "",
		type: "School",
	};

	const validate = Yup.object().shape({
		name: Yup.string().required("Name of institution is required"),
		level: Yup.string().required("Level of institution is required"),
		country: Yup.string().required("Country is required"),
		province: Yup.string().when("country", {
			is: (val) => val === "Zimbabwe",
			then: Yup.string().required("Province is required"),
		}),
		contact_number: Yup.string()
			.nullable()
			.test("phone", "Use a valid phone number with country code", (value) => {
				if (!value) return true;
				return phoneRegex.test(value) && value.length >= 10 && value.length <= 20;
			}),
	});

	const handleSave = async (data) => {
		await mutateAsync({
			...data,
			type: data.type || "School",
		});
	};

	return (
		<div>
			<p className="text-base text-gray-700">
				Register your school or organization. After you create it, your account becomes an
				institution admin account.
			</p>
			<p className="mt-1 text-sm text-gray-500">Fields marked (*) are required</p>

			<div className="mt-4 pt-4">
				<Formik
					initialValues={initialValues}
					validationSchema={validate}
					onSubmit={(data) => handleSave(data)}
				>
					{({ values }) => (
						<Form className="account-security-fields">
							<AccountField name="name" label="Name of Institution *" />

							<AccountField
								type="select"
								name="level"
								label="Institution Level *"
								options={institutionLevels.map((level) => ({
									label: level.name,
									value: level.value,
								}))}
							/>

							<AccountField
								type="select"
								name="country"
								label="Country *"
								options={countries.map((country) => ({
									label: country.name,
									value: country.name,
								}))}
							/>

							<div className={`relative ${values.country === "Zimbabwe" ? "" : "hidden"}`}>
								<AiOutlineLoading3Quarters
									size={20}
									className={`${
										isLoadingProvinces ? "animate-spin" : "hidden"
									} absolute top-2 right-14 z-10`}
								/>
								<AccountField
									type="select"
									name="province"
									label="Province *"
									disabled={isLoadingProvinces}
									options={provinces?.map((province) => ({
										label: province.name,
										value: province.name,
									}))}
								/>
							</div>

							<AccountField
								name="contact_number"
								type="phone"
								label="Contact Number"
								optional
								autoComplete="tel"
								// placeholder="+263 77 123 4567"
							/>

							<AccountField name="address" label="Physical Address" />

							<div className="mt-4 flex items-center">
								<button type="submit" className="account-button" disabled={isLoading}>
									Create institution
									{isLoading && <AiOutlineLoading3Quarters size={20} className="animate-spin" />}
								</button>
							</div>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
};

export default CreateInstitution;
